export const elementIds = {
  SCROLL_CONTAINER: "scrollContainer",
};
